import { alpha } from "@mui/material";

// Selo do ERP de origem. Mesma base do selo PF/PJ (components/tipoCliente),
// com uma cor por tipo de ERP vinda da paleta do tenant.
const seloBase = {
  height: 22,
  minWidth: 64,
  fontWeight: 600,
  fontSize: "0.7rem",
  letterSpacing: "0.04em",
  borderRadius: "6px",
};

// Para um ERP novo, acrescente aqui a cor dele (chave = Erp.tipo).
const CORES_POR_ERP = {
  HUBSOFT: (theme) => theme.palette.colors.blue.medium,
  IXC: (theme) => theme.palette.colors.orange.medium,
};

const styles = (theme) => {
  const selo = (cor) => ({
    ...seloBase,
    color: cor,
    backgroundColor: alpha(cor, 0.15),
    border: `1px solid ${alpha(cor, 0.4)}`,
  });

  return {
    porTipo: Object.fromEntries(
      Object.entries(CORES_POR_ERP).map(([tipo, cor]) => [tipo, selo(cor(theme))]),
    ),
    // ERP sem cor definida: tom neutro.
    padrao: {
      ...seloBase,
      color: theme.palette.chip.colorText.medium,
      backgroundColor: theme.palette.chip.background.medium,
    },
  };
};

export default styles;
